
interface TeamStats {
  played: number;
  points: number;
  wins: number;
  draws: number;
  losses: number;
  halfTimeWins: number;
  halfTimeDraws: number;
  halfTimeLosses: number;
  cleanSheets: number;
  btts: number;
  htBtts: number;
  yellowCards?: { home: number; away: number };
  redCards?: { home: number; away: number };
  teamGoalsOver?: { [key: string]: number };
  halfTimeTeamGoalsOver?: { [key: string]: number };
  teamCornersOver?: { [key: string]: number };
  teamCardsOver?: { [key: string]: number };
}

export const calculateTeamStats = (matches: any[], team: string): TeamStats => {
  const yellowCards = {
    home: matches.filter(match => match.HomeTeam === team).reduce((acc, match) => acc + parseInt(match.HY || '0'), 0),
    away: matches.filter(match => match.AwayTeam === team).reduce((acc, match) => acc + parseInt(match.AY || '0'), 0)
  };

  const redCards = {
    home: matches.filter(match => match.HomeTeam === team).reduce((acc, match) => acc + parseInt(match.HR || '0'), 0),
    away: matches.filter(match => match.AwayTeam === team).reduce((acc, match) => acc + parseInt(match.AR || '0'), 0)
  };

  // Calculate team goals over thresholds
  const teamGoalsOver: { [key: string]: number } = {};
  const halfTimeTeamGoalsOver: { [key: string]: number } = {};
  const goalThresholds = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5];

  goalThresholds.forEach(threshold => {
    teamGoalsOver[threshold] = matches.filter(match => {
      const goals = match.HomeTeam === team ? parseInt(match.FTHG) : parseInt(match.FTAG);
      return goals > threshold;
    }).length;

    halfTimeTeamGoalsOver[threshold] = matches.filter(match => {
      const goals = match.HomeTeam === team ? parseInt(match.HTHG) : parseInt(match.HTAG);
      return goals > threshold;
    }).length;
  });

  // Calculate team corners over thresholds
  const teamCornersOver: { [key: string]: number } = {};
  const cornerThresholds = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5, 6.5, 7.5, 8.5, 9.5, 10.5, 11.5, 12.5];

  cornerThresholds.forEach(threshold => {
    teamCornersOver[threshold] = matches.filter(match => {
      const corners = match.HomeTeam === team ? parseInt(match.HC) : parseInt(match.AC);
      return corners > threshold;
    }).length;
  });

  // Calculate team cards over thresholds
  const teamCardsOver: { [key: string]: number } = {};
  const cardThresholds = [0.5, 1.5, 2.5, 3.5, 4.5, 5.5, 6.5];

  cardThresholds.forEach(threshold => {
    teamCardsOver[threshold] = matches.filter(match => {
      const yellowCardValue = match.HomeTeam === team ? parseInt(match.HY || '0') : parseInt(match.AY || '0');
      const redCardValue = match.HomeTeam === team ? parseInt(match.HR || '0') : parseInt(match.AR || '0');
      const totalCards = yellowCardValue + (redCardValue * 2);
      return totalCards > threshold;
    }).length;
  });

  return {
    played: matches.length,
    points: matches.reduce((acc, match) => {
      if (match.HomeTeam === team) {
        return acc + (match.FTR === 'H' ? 3 : match.FTR === 'D' ? 1 : 0);
      } else if (match.AwayTeam === team) {
        return acc + (match.FTR === 'A' ? 3 : match.FTR === 'D' ? 1 : 0);
      }
      return acc;
    }, 0),
    wins: matches.filter(match => 
      (match.HomeTeam === team && match.FTR === 'H') ||
      (match.AwayTeam === team && match.FTR === 'A')
    ).length,
    draws: matches.filter(match => match.FTR === 'D').length,
    losses: matches.filter(match => 
      (match.HomeTeam === team && match.FTR === 'A') ||
      (match.AwayTeam === team && match.FTR === 'H')
    ).length,
    halfTimeWins: matches.filter(match => 
      (match.HomeTeam === team && match.HTR === 'H') ||
      (match.AwayTeam === team && match.HTR === 'A')
    ).length,
    halfTimeDraws: matches.filter(match => match.HTR === 'D').length,
    halfTimeLosses: matches.filter(match => 
      (match.HomeTeam === team && match.HTR === 'A') ||
      (match.AwayTeam === team && match.HTR === 'H')
    ).length,
    cleanSheets: matches.filter(match => 
      (match.HomeTeam === team && parseInt(match.FTAG) === 0) ||
      (match.AwayTeam === team && parseInt(match.FTHG) === 0)
    ).length,
    btts: matches.filter(match => 
      parseInt(match.FTHG) > 0 && parseInt(match.FTAG) > 0
    ).length,
    htBtts: matches.filter(match => 
      parseInt(match.HTHG) > 0 && parseInt(match.HTAG) > 0
    ).length,
    yellowCards,
    redCards,
    teamGoalsOver,
    halfTimeTeamGoalsOver,
    teamCornersOver,
    teamCardsOver
  };
};
